'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var reactIntl = require('react-intl');
var ErrorText = require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');

var Validator = function (props) {
    var data = props.data, validators = props.validators, shouldValidate = props.shouldValidate, reportErrors = props.reportErrors, renderChild = props.renderChild, _a = props.error, error = _a === void 0 ? false : _a, _b = props.errors, errors = _b === void 0 ? [] : _b, _c = props.renderErrors, renderErrors = _c === void 0 ? false : _c, _d = props.forceValidation, forceValidation = _d === void 0 ? false : _d;
    var fm = reactIntl.useIntl().formatMessage;
    var _e = React.useState([]), newErrors = _e[0], setNewErrors = _e[1];
    React.useEffect(function () {
        var mounted = true; // https://www.debuggr.io/react-update-unmounted-component/
        var getErrors = function () { return tslib.__awaiter(void 0, void 0, void 0, function () {
            var promises, resolvedErrors, filteredErrors;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = validators.map(function (validator) {
                            return Promise.resolve(validator(data, fm));
                        });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        resolvedErrors = _a.sent();
                        filteredErrors = resolvedErrors.filter(function (e) { return e.error; });
                        if (mounted) {
                            setNewErrors(filteredErrors);
                        }
                        if (shouldValidate && reportErrors) {
                            reportErrors(filteredErrors);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (shouldValidate) {
            getErrors();
        }
        return function () {
            mounted = false;
        };
    }, [data, shouldValidate, forceValidation]);
    if (!shouldValidate) {
        return renderChild(error, errors);
    }
    var newError = !!newErrors.length;
    return (React__default.createElement(React__default.Fragment, null,
        renderChild(newError, newErrors),
        renderErrors && newError && (React__default.createElement(ErrorText, { style: { marginTop: '0.1rem' } }, newErrors[0].messageFragment))));
};

module.exports = Validator;
